import { Link } from 'react-router-dom';

export default function AppDownloadSection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          {/* 图片 */}
          <div className="rounded-2xl overflow-hidden aspect-[16/9] mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20entertainment%20news%20app%20interface%20with%20breaking%20news%20feed%2C%20warm%20amber%20and%20dark%20moody%20background%2C%20cinematic%20lighting%2C%20premium%20app%20mockup%20presentation%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20professional%20composition&width=1200&height=675&seq=app-download-2026-x1&orientation=landscape"
              alt="吃瓜爆料网APP下载"
              className="w-full h-full object-cover"
              title="吃瓜爆料网APP下载"
              loading="lazy"
            />
          </div>

          {/* 文案 */}
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3 leading-tight">
            下载<span className="italic font-normal text-secondary-400 mx-1">吃瓜爆料网</span>APP
          </h2>
          <p className="text-base md:text-lg text-foreground-600 mb-2 leading-relaxed">
            随时随地，<strong>黑料大瓜</strong>不错过
          </p>
          <p className="text-sm text-foreground-500 mb-10 leading-relaxed">
            网红塌房、反差视频、聊天记录曝光，第一时间推送至您的手中
          </p>

          {/* CTA 按钮 */}
          <Link
            to="/about"
            className="whitespace-nowrap inline-flex items-center gap-2 px-10 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-download-2-line text-lg" />
            立即下载APP
          </Link>
        </div>
      </div>
    </section>
  );
}